import HistoryOutlined from '@mui/icons-material/HistoryOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { t } from 'i18next';
import { useState } from 'react';

import PricingEventsHistory from '~components/PricingHistory/PricingEventsHistory';
import { RatesHistoryAnalyticsSurface } from '~components/PricingHistory/PricingHistoryButton';
import PricingHistoryPanel from '~components/PricingHistory/PricingHistoryPanel';
import { AnalyticsController } from '~hooks/useAnalytics/AnalyticsController';
import { Job } from '~hooks/useJob/models';
import { Order } from '~hooks/useOrders/models';

interface OrderPricingHistoryButtonProps {
  order: Order;
  jobs: Job[];
  analyticsSurface: RatesHistoryAnalyticsSurface;
}

/**
 * Rate-column-header trigger that opens the pricing-history panel for an Order — defaulting to the
 * whole order and letting the user pick a single job (see PricingEventsHistory).
 */
export default function OrderPricingHistoryButton({
  order,
  jobs,
  analyticsSurface,
}: OrderPricingHistoryButtonProps) {
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  return (
    <>
      <Tooltip title={t('loads.pricing.pricing_history')}>
        <IconButton
          aria-label={t('loads.pricing.pricing_history')}
          onClick={(event) => {
            event.stopPropagation();
            AnalyticsController.track('rates_history_viewed', {
              scope: 'order',
              surface: analyticsSurface,
            });
            setIsPanelOpen(true);
          }}
          size="small"
        >
          <HistoryOutlined
            sx={(theme) => ({ color: theme.brandV2.colors.treadBlack, fontSize: '18px' })}
          />
        </IconButton>
      </Tooltip>

      <PricingHistoryPanel
        isOpen={isPanelOpen}
        onClose={() => setIsPanelOpen(false)}
        subtitle={t('loads.pricing.history.order_ref', { ref: order.orderId })}
        title={t('loads.pricing.pricing_history')}
      >
        <PricingEventsHistory jobs={jobs} order={order} />
      </PricingHistoryPanel>
    </>
  );
}
